import { connect } from 'react-redux';

//import { rejectModVersion, removeModVersion } from '../../actions/EditMod';
import { closeDialog } from '../../actions/Dialog';

import DialogConfirmation
    from '../../components/Dialogs/DialogConfirmation/DialogConfirmation';
import { deleteComment, hideComment, showComment } from '../../actions/EditMod';

const mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    modId: ownProps.modId,
    type: ownProps.type,
    isHide: ownProps.isHide,
    isCommentMode: ownProps.isCommentMode,
})

const mapDispatchToProps = (dispatch) => ({
    onCloseDialog: () => {
        dispatch(closeDialog())
    },
    onSubmitDialog: (eachId) => {
        //dispatch(removeModVersion(eachId))
        dispatch(closeDialog())
    },

    onHideComment: (commentId, modId, type) => {
        dispatch(hideComment( commentId, modId, type ))
        dispatch(closeDialog())
    },
    onShowComment: (commentId, modId, type) => {
        dispatch(showComment( commentId, modId, type ))
        dispatch(closeDialog())
    },
    onDeleteComment: (commentId, modId, type) => {
        dispatch(deleteComment( commentId, modId, type ))
        dispatch(closeDialog())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(DialogConfirmation)